import React, { useEffect, useState } from "react";
import Loader from "./Loader";
import { Button } from "react-bootstrap";

const ConfirmationPopupWithLink = ({
  isOpen,
  title,
  message,
  onClose,
  onCreateLink,
  linkToCopy = "https://jobcritics.com/get-more-rating/default",
  loading,
}) => {
  const [showLoader, setShowLoader] = useState(true);
  const [copied, setCopied] = useState(false);

  // Handle copy action
  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(linkToCopy)
        .then(() => {
          setCopied(true);
          onCreateLink?.();
          setTimeout(() => setCopied(false), 1500); // Reset after 1.5 seconds
        })
        .catch((err) => {
          console.error("Clipboard API failed", err);
          fallbackCopy(linkToCopy);
          setCopied(true);
          setTimeout(() => setCopied(false), 1500); // Reset after 1.5 seconds
        });
    } else {
      fallbackCopy(linkToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500); // Reset after 1.5 seconds
    }
  };

  // Fallback for older browsers
  const fallbackCopy = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.top = "-9999px";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        onCreateLink?.();
      }
    } catch (err) {
      console.error("Fallback copy failed", err);
    }

    document.body.removeChild(textarea);
  };

  // Handle modal open/close and loader
  useEffect(() => {
    if (isOpen) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";

      setShowLoader(true);
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 1000);

      return () => {
        clearTimeout(timer);
        document.documentElement.style.overflow = "auto";
        document.body.style.overflow = "auto";
        setCopied(false); // Reset copied state on unmount
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    window.location.reload();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-d">
      {showLoader ? (
        <Loader />
      ) : (
        <div className="bg-white p-[23px] pb-[15px] rounded-[27px] shadow-xl  wi_cl relative flex flex-col">


          {/* Title & Message */}
          <p className="text-gray-600 text-center flex items-center justify-center  p-[1px]">
            <img
              src="https://jobcritics.com/assets/img/biar/success.webp"
              alt="Delete"
              className="w-[150px] mr-2"
            />
          </p>
          <h6 className="font-semibold text-black text-center w-full mb-0 mt-[6px] pb-[5px]">{message}</h6>
          <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
            Your details have been updated successfully.
          </p>
          <p className="text-gray-600 text-center text-[13px] leading-[1.6] ">
          Share this link with connections for credibility.
          </p>

          {/* Link field & button styled like input group */}
          <div className="grid mt-[11px] w-full gap-3 w-full justify-center">
            <Button
              onClick={handleCopy}
              className={` ${copied
                ? "btn-explore-yellow-disabled !border-gray-300 !border-[1px] disabled:!cursor-not-allowed disabled:!bg-gray-300 disabled:opacity-50 disabled:hover:!border-gray-300 disabled:hover:!bg-gray-300 disabled:!text-white disabled:hover:!text-white text-c pd3 !w-[300px]"
                : "btn-explore-yellow  text-c pd3 !w-[300px]"
                }`}
              disabled={copied}
            >
              {copied ? "Copied!" : "🔗 Copy link"}
            </Button>
            <p
              className="text-gray-700  hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px] "
              onClick={handleClose}
            >
              CLOSE
            </p>
          </div>
        </div>

      )}
    </div>
  );
};

export default ConfirmationPopupWithLink;